import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { Providers } from '../enums/providers';
import Global from '../store/global-selectors';

const isProviderLocalDelivery = {
  [Providers.Uber.labelProviderId]: true,
};

export const getIsProviderLocalDelivery = (labelProviderId) => {
  return isProviderLocalDelivery[labelProviderId] || false;
};

export const useFilteredLocalDeliveryProviders = (sellerLabelProviders) => {
  const globalSellerLabelProviders = useSelector(Global.selectSellerLabelProviders);
  const providers = sellerLabelProviders || globalSellerLabelProviders;
  return useMemo(() => providers.filter(({ labelProviderId }) => !getIsProviderLocalDelivery(labelProviderId)), [providers]);
};
